import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-white py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-75">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-navy/5 -skew-x-12 transform origin-top-right" data-id="element-76"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-78">
          <div className="inline-flex items-center justify-center px-4 py-2 bg-navy text-white rounded-full mb-8 font-bold tracking-wide text-sm uppercase" data-id="element-79">
            <Zap className="w-4 h-4 mr-2 text-orange" data-id="element-80" />
            La Solución Definitiva
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl text-charcoal mb-8 leading-tight" data-id="element-81">
            Presentamos el método de <br className="hidden md:block" data-id="element-82" />
            <span className="text-navy bg-navy/10 px-2 py-1 rounded" data-id="element-83">
              Descompresión Pasiva de 4 Minutos
            </span>
          </h2>

          <div className="space-y-6 font-body text-lg text-warm-gray leading-[1.7]" data-id="element-84">
            <p data-id="element-85">
              <strong className="text-charcoal" data-id="element-86">
                No es ejercicio, es arquitectura corporal.
              </strong>
            </p>
            <p data-id="element-87">
              Este protocolo utiliza la gravedad y posiciones clave de reposo
              para separar tus vértebras milimétricamente. Ese pequeño espacio
              es suficiente para que la sangre fluya de nuevo, el disco se
              retraiga y el nervio ciático deje de estar "atrapado".
            </p>
            <div className="p-6 bg-green/10 border-l-4 border-green rounded-r-lg mt-8" data-id="element-88">
              <p className="text-charcoal font-medium" data-id="element-89">
                Es la forma más rápida y natural de liberar la presión desde la
                comodidad de tu casa, sin pastillas ni visitas al quiropráctico.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}